import transitionPath from "router5-transition-path";
import { actionTypes as routerActions } from "redux-router5";
import { take, fork } from "redux-saga/effects";

export default function* onRouteEnter(routeToEnter, saga, ...params) {
  while (true) {
    const {
      payload: { route, previousRoute }
    } = yield take(routerActions.TRANSITION_SUCCESS);

    const { toActivate } = transitionPath(route, previousRoute);

    if (toActivate.some(activatedRoute => activatedRoute === routeToEnter)) {
      yield fork(saga, ...params);
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/routing/on-route-enter-saga.js